export namespace AuthStates {
    export function authStatesFactory() {
        const auth: any = {
            userInfo: {
                value: {},
                timestamp: new Date()
            },
            storeInfo: {
                value: {},
                timestamp: new Date()
            },
            userName: '',
            userUrl: '',
            clientC: {
                value: undefined,
                timestamp: new Date()
            },
        };
        return auth;
    }

    export function mutations() {
        return {
            setUser(state: any, data: any) {
                state.auth.userInfo.value = data;
                state.auth.userInfo.timestamp = new Date();
            },
            setStoreInfo(state: any, data: any) {
                state.auth.storeInfo.value = data;
                state.auth.storeInfo.timestamp = new Date();
            },
            setUserName(state: any, userName: any) {
                state.auth.userName = userName;
            },
            setClientCLogin(state: any, clientC: any) {
                state.auth.clientC.value = clientC;
                state.auth.clientC.timestamp = new Date();
            },
            logout(state: any) {
                state.auth.clientC = {
                    value: undefined,
                    timestamp: new Date()
                };
            },
        };
    }
}
